import React from 'react';
import { AdminOrganization, OrganizationMember } from '../../../types/domain';
import { InnerLayoutSection } from '../../../components/layout/InnerLayout';

interface AdminOrgQuotasTabProps {
  organization: AdminOrganization;
  members: OrganizationMember[];
  totalDatastores: number;
  onOpenEditQuotaDrawer: () => void;
}

export const AdminOrgQuotasTab: React.FC<AdminOrgQuotasTabProps> = ({
  organization,
  members,
  totalDatastores,
  onOpenEditQuotaDrawer,
}) => {
  return (
    <InnerLayoutSection
      title="Quota & Ingestion Limits"
      description="Subscription plan parameters, submission ceilings, and datastore boundaries."
      actions={[
        {
          label: 'Adjust Quotas',
          variant: 'primary',
          onClick: onOpenEditQuotaDrawer,
        },
      ]}
    >

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-cf-surface border border-cf-border rounded-lg p-4 space-y-2">
          <span className="text-xs uppercase text-cf-textMuted font-medium">Monthly Submissions</span>
          <div className="text-xl font-bold text-cf-textPrimary">
            {(organization.submissions_used || 0).toLocaleString()} / {(organization.max_monthly_submissions || 500).toLocaleString()}
          </div>
          <div className="w-full bg-cf-bg h-2 rounded-full overflow-hidden border border-cf-border">
            <div
              className="bg-cf-orange h-full rounded-full transition-all"
              style={{
                width: `${Math.min(
                  100,
                  ((organization.submissions_used || 0) / (organization.max_monthly_submissions || 500)) * 100
                )}%`,
              }}
            />
          </div>
        </div>

        <div className="bg-cf-surface border border-cf-border rounded-lg p-4 space-y-2">
          <span className="text-xs uppercase text-cf-textMuted font-medium">Datastores / Tables</span>
          <div className="text-xl font-bold text-cf-textPrimary">
            {totalDatastores} / {organization.max_tables || 3}
          </div>
          <div className="w-full bg-cf-bg h-2 rounded-full overflow-hidden border border-cf-border">
            <div
              className="bg-blue-500 h-full rounded-full transition-all"
              style={{
                width: `${Math.min(
                  100,
                  (totalDatastores / (organization.max_tables || 3)) * 100
                )}%`,
              }}
            />
          </div>
        </div>

        <div className="bg-cf-surface border border-cf-border rounded-lg p-4 space-y-2">
          <span className="text-xs uppercase text-cf-textMuted font-medium">Team Seats</span>
          <div className="text-xl font-bold text-cf-textPrimary">
            {members.length} / {organization.max_team_seats || 2}
          </div>
          <div className="w-full bg-cf-bg h-2 rounded-full overflow-hidden border border-cf-border">
            <div
              className="bg-emerald-500 h-full rounded-full transition-all"
              style={{
                width: `${Math.min(
                  100,
                  (members.length / (organization.max_team_seats || 2)) * 100
                )}%`,
              }}
            />
          </div>
        </div>
      </div>
    </InnerLayoutSection>
  );
};
